<template>
  <div v-loading="loading">
    <Form>
      <Row>
        <Col span="6">
          <FormItem :label="l('PEIXUNBANJI')">{{item.name}}</FormItem>
        </Col>
        <Col span="18">
          <FormItem :label="l('SHIJIANFANWEI')">{{item.beginTime}}-{{item.endTime}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('BANJIBIANHAO')">{{item.subtitle}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SHISHIBUMEN')">{{item.orgName}}</FormItem>
        </Col>
      </Row>
      <Row>
       
        <Col span="6">
          <FormItem :label="l('PEIXUNDIDIAN')">{{item.trainAddress}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KESHI')">{{item.sumClassHour}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('XUEFEN')">{{item.sumClassCredit}}</FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "trainClassAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainProjectClass/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// trainClassAudit.vue?76a5beee